import React from 'react';
import { motion } from 'framer-motion';
import { Zap, TrendingUp, Trophy } from 'lucide-react';
export function ResultsTimeline() {
  return <section className="py-20 bg-white" data-id="element-142">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-145">
            Lo que notarás (y cuándo)
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start mb-12" data-id="element-146">
          {/* 48 Hours */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl shadow-lg overflow-hidden bg-white border border-stone-100" data-id="element-147">
            <div className="bg-amber-400 p-6 text-center" data-id="element-148">
              <div className="flex justify-center mb-2" data-id="element-149">
                <Zap className="w-8 h-8 text-white" data-id="element-150" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-151">En 48 horas</h3>
            </div>
            <div className="p-8" data-id="element-152">
              <ul className="space-y-3" data-id="element-153">
                <li className="flex items-start gap-2 text-stone-600" data-id="element-154">
                  <span className="text-amber-500 font-bold" data-id="element-155">•</span> Menos
                  repeticiones
                </li>
                <li className="flex items-start gap-2 text-stone-600" data-id="element-156">
                  <span className="text-amber-500 font-bold" data-id="element-157">•</span> Menos
                  resistencia inicial
                </li>
                <li className="flex items-start gap-2 text-stone-600" data-id="element-158">
                  <span className="text-amber-500 font-bold" data-id="element-159">•</span> Más
                  cooperación «por inercia»
                </li>
                <li className="flex items-start gap-2 text-stone-600" data-id="element-160">
                  <span className="text-amber-500 font-bold" data-id="element-161">•</span> Tu tono
                  más estable
                </li>
              </ul>
            </div>
          </motion.div>

          {/* 7 Days - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="rounded-2xl shadow-xl overflow-hidden bg-white ring-4 ring-emerald-100 transform md:-translate-y-4" data-id="element-162">
            <div className="bg-emerald-500 p-6 text-center relative" data-id="element-163">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-emerald-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-164">
                El cambio real
              </div>
              <div className="flex justify-center mb-2" data-id="element-165">
                <TrendingUp className="w-8 h-8 text-white" data-id="element-166" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-167">En 7 días</h3>
            </div>
            <div className="p-8" data-id="element-168">
              <ul className="space-y-4" data-id="element-169">
                <li className="flex items-start gap-2 text-stone-700 font-medium" data-id="element-170">
                  <span className="text-emerald-500 font-bold text-xl" data-id="element-171">✓</span>{' '}
                  Transiciones más fluidas
                </li>
                <li className="flex items-start gap-2 text-stone-700 font-medium" data-id="element-172">
                  <span className="text-emerald-500 font-bold text-xl" data-id="element-173">✓</span>{' '}
                  Rutinas más automáticas
                </li>
                <li className="flex items-start gap-2 text-stone-700 font-medium" data-id="element-174">
                  <span className="text-emerald-500 font-bold text-xl" data-id="element-175">✓</span>{' '}
                  Menos tensión acumulada
                </li>
              </ul>
            </div>
          </motion.div>

          {/* 14 Days */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="rounded-2xl shadow-lg overflow-hidden bg-white border border-stone-100" data-id="element-176">
            <div className="bg-blue-500 p-6 text-center" data-id="element-177">
              <div className="flex justify-center mb-2" data-id="element-178">
                <Trophy className="w-8 h-8 text-white" data-id="element-179" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-180">En 14 días</h3>
            </div>
            <div className="p-8" data-id="element-181">
              <ul className="space-y-3" data-id="element-182">
                <li className="flex items-start gap-2 text-stone-600" data-id="element-183">
                  <span className="text-blue-500 font-bold" data-id="element-184">•</span> Hábitos
                  visibles
                </li>
                <li className="flex items-start gap-2 text-stone-600" data-id="element-185">
                  <span className="text-blue-500 font-bold" data-id="element-186">•</span> Mayor
                  autonomía
                </li>
                <li className="flex items-start gap-2 text-stone-600" data-id="element-187">
                  <span className="text-blue-500 font-bold" data-id="element-188">•</span> Un hogar
                  más predecible
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        <div className="max-w-3xl mx-auto text-center" data-id="element-189">
          <p className="text-stone-500 italic" data-id="element-190">
            No porque te transformes mágicamente. Sino porque el tablero hace el
            trabajo pesado: toma lo que estaba en tu garganta y lo pone en la
            pared.
          </p>
        </div>
      </div>
    </section>;
}